import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useId } from '../../Utils/Hooks';
import { Popover } from '../Popover';

import * as Styles from './index.styles';

const {
    StyledFormGroup,
    StyledLabel,
    StyledRadioButtons,
    StyledText,
    StyledHelperContainer,
} = Styles;

export const DisplayRadioFormGroup = ({
    id,
    name,
    groupLabel,
    onChange,
    vertical,
    border,
    disabled,
    message,
    children,
    fullWidth,
    bottomTextWidth,
    helperContent,
    ...otherProps
}) => {
    const [open, setOpen] = useState(false);

    const [groupId] = useId('display-radio', id);

    return (
        <StyledFormGroup
            name={name}
            vertical={vertical}
            border={border}
            onChange={onChange}
            fullWidth={fullWidth}
            {...otherProps}
        >
            <StyledLabel>
                {groupLabel}
                {helperContent && !disabled && (
                    <StyledHelperContainer
                        id={`display-radio-helper-button${groupId}`}
                        data-test-id="help-btn"
                        onClick={() => setOpen(prev => !prev)}
                    >
                        <FontAwesomeIcon icon={['fas', 'info']} />
                    </StyledHelperContainer>
                )}
            </StyledLabel>
            <StyledRadioButtons fullWidth={fullWidth}>{children}</StyledRadioButtons>
            {message && (
                <StyledText small fullWidth={fullWidth} bottomTextWidth={bottomTextWidth}>
                    {message}
                </StyledText>
            )}
            {helperContent && (
                <Popover
                    bindTo={`display-radio-helper-button${groupId}`}
                    open={!disabled && open}
                    onClose={() => setOpen(false)}
                    width="300px"
                    enableMobile
                    darkMode
                >
                    <div data-test-id="help-content">{helperContent}</div>
                </Popover>
            )}
        </StyledFormGroup>
    );
};

DisplayRadioFormGroup.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    groupLabel: PropTypes.string,
    fullWidth: PropTypes.bool,
    vertical: PropTypes.bool,
    border: PropTypes.bool,
    disabled: PropTypes.bool,
    message: PropTypes.string,
    bottomTextWidth: PropTypes.string,
    helperContent: PropTypes.node,
    children: PropTypes.node,
    onChange: PropTypes.func,
};

/* istanbul ignore next */
DisplayRadioFormGroup.defaultProps = {
    id: '',
    name: '',
    groupLabel: '',
    vertical: false,
    fullWidth: false,
    border: false,
    disabled: false,
    message: '',
    bottomTextWidth: '320px',
    helperContent: undefined,
    children: undefined,
    onChange: () => undefined,
};

DisplayRadioFormGroup.Styles = Styles;
